import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { ConfigureService } from '@app/configure/services/configure.service';
import { ModalService } from '@app/core/services/modal.service';
import { HelperService } from '@app/core/services/helper.service';

import { FinanceQuote } from '@app/core/models/finance-quote.model';

@Component({
	selector: 'cng-fixed-footer',
	templateUrl: './fixed-footer.component.html',
	styleUrls: ['./fixed-footer.component.less'],
})
export class FixedFooterComponent implements OnInit, OnDestroy {
	@Input() loading: boolean = false;

	vehicle: any = this.configure_service.configure_data.steps.purchase_vehicle.data;

	cashback_deal: boolean = this.configure_service.configure_data.meta.cashback_deal;
	finance_meta: any = this.configure_service.configure_data.meta.finance;
	stacked_quotes: FinanceQuote[] = this.configure_service.configure_data.steps.finance_options.data;
	selected_quote: FinanceQuote = this.helper_service.copy(this.stacked_quotes).find((quote: FinanceQuote) => {
		return quote.selected;
	});
	grand_total: number = this.configure_service.configure_data.steps.customise_review.data.grand_total;
	grand_total_net: number = this.configure_service.configure_data.steps.customise_review.data.grand_total_net;
	grand_total_vat: number = this.configure_service.configure_data.steps.customise_review.data.grand_total_vat;
	part_exchanges: any = this.configure_service.configure_data.steps.part_exchange.data.filter((item) => {
		return item.vehicle !== null;
	});

	has_pex: boolean =
		this.part_exchanges !== null &&
		this.part_exchanges.length > 0 &&
		this.part_exchanges[0].vehicle.allowance !== null;
	pex_subtotal: number = 0;
	pex_subtotal_adjusted: boolean = false;
	deposit: number = 0;

	destroyed$: Subject<boolean> = new Subject<boolean>();

	constructor(
		private configure_service: ConfigureService,
		private modal_service: ModalService,
		private helper_service: HelperService
	) {}

	ngOnInit(): void {
		this.setPartExSubTotal();
		this.setDeposit();

		this.configure_service.configure_data$.pipe(takeUntil(this.destroyed$)).subscribe((configure_data) => {
			this.cashback_deal = configure_data.meta.cashback_deal;
			this.finance_meta = configure_data.meta.finance;
			this.stacked_quotes = configure_data.steps.finance_options.data;
			this.selected_quote = this.helper_service.copy(this.stacked_quotes).find((quote) => {
				return quote.selected;
			});
			this.grand_total = configure_data.steps.customise_review.data.grand_total;
			this.grand_total_net = configure_data.steps.customise_review.data.grand_total_net;
			this.grand_total_vat = configure_data.steps.customise_review.data.grand_total_vat;
			this.part_exchanges = configure_data.steps.part_exchange.data.filter((item) => {
				return item.vehicle !== null;
			});

			this.has_pex =
				this.part_exchanges !== null &&
				this.part_exchanges.length > 0 &&
				this.part_exchanges[0].vehicle.allowance !== null;

			this.setPartExSubTotal();
			this.setDeposit();
		});
	}

	setPartExSubTotal(): void {
		this.pex_subtotal_adjusted = false;

		if (!this.has_pex) {
			this.pex_subtotal = 0;
			this.pex_subtotal_adjusted = true;
			return;
		}

		if (
			this.part_exchanges[0].vehicle.finance_settlement === null ||
			this.part_exchanges[0].vehicle.finance_settlement === 0
		) {
			this.pex_subtotal = this.part_exchanges[0].vehicle.allowance;
			return;
		}

		const pex_subtotal: number =
			this.part_exchanges[0].vehicle.allowance - this.part_exchanges[0].vehicle.finance_settlement;

		if (pex_subtotal < 0) {
			this.pex_subtotal = 0;
			this.pex_subtotal_adjusted = true;
			return;
		}

		this.pex_subtotal = pex_subtotal;
	}

	setDeposit(): void {
		if (this.finance_meta.enabled && typeof this.selected_quote !== 'undefined') {
			this.deposit = this.selected_quote.total_deposit;
		}
	}

	onShowDepositBreakdown(tabToShow: string): void {
		this.modal_service.show(['configure/full-breakdown'], { tabToShow });
	}

	ngOnDestroy(): void {
		this.destroyed$.next(true);
	}
}
